import { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { BackButton, SaveButton, Step, Steps, StyledButton, Title } from './styles';
import { ButtonsContainer } from '../../containers/ReportForm/styles';
import ReportFormRenderContent from '../ReportFormRenderContent';

export const ReviewTicketFormTemplateSteps = ({
  handleFormSubmit,
  inputValues,
  requiredFields,
  setInputValues,
  inputLabels,
  setInputLabels,
  reportFormData,
  isPreview,
  setIsPreview,
  currentStep,
  setCurrentStep,
  isPreviewTicket,
  handleChatCustomer,
  customer,
}) => {
  const intl = useIntl();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const requiredFieldKeys = Object.keys(requiredFields).filter((key) => requiredFields[key]);
    const allRequiredFieldsFilled = requiredFieldKeys.every((fieldKey) => {
      const value = inputValues[fieldKey];
      return value !== null && value !== undefined && value !== '';
    });
    setIsFormValid(allRequiredFieldsFilled);
  }, [inputValues, requiredFields]);

  const handleNextStep = (e) => {
    e.preventDefault();
    setCurrentStep(currentStep + 1);
  };
  const showPreview = (e) => {
    e.preventDefault();
    setIsPreview(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!disableSubmit && isFormValid) {
      setTimeout(async () => {
        await handleFormSubmit(e);
        setDisableSubmit(false);
      });
    }
    setDisableSubmit(true);
  };

  return (
    <>
      {isPreview ? (
        <Title>
          <FormattedMessage id="reviews.reportForm.title.preview" />
        </Title>
      ) : (
        <>
          <Title>
            <FormattedMessage
              id="reviews.reportForm.title.fill"
              defaultMessage="reviews.reportForm.title.fill"
              values={{
                text: intl.formatMessage({
                  id: 'reviews.reportForm.title.fill.text',
                  defaultMessage: 'reviews.reportForm.title.fill.text',
                }),
              }}
            />
          </Title>
          <Steps>
            {reportFormData.map((step, index) => (
              <Step
                $isActive={index === currentStep}
                $isComplete={index < currentStep}
                $step={index + 1}
                key={`step-${index}`}
              >
                <FormattedMessage id={step.stepName} />
              </Step>
            ))}
          </Steps>
        </>
      )}

      <form autoComplete="off">
        <ReportFormRenderContent
          inputValues={inputValues}
          requiredFields={requiredFields}
          setInputValues={setInputValues}
          inputLabels={inputLabels}
          setInputLabels={setInputLabels}
          reportFormData={reportFormData}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          isPreview={isPreview}
          setIsPreview={setIsPreview}
          isPreviewTicket={isPreviewTicket}
        />
        {!isPreviewTicket && (
          <ButtonsContainer>
            {currentStep === reportFormData.length - 1 ? (
              <>
                {!isPreview && (
                  <StyledButton onClick={showPreview}>
                    <FormattedMessage
                      id="reviews.reportForm.button.preview"
                      defaultMessage="Preview"
                    />
                  </StyledButton>
                )}
                <SaveButton
                  type="submit"
                  onClick={handleSubmit}
                  disabled={disableSubmit || !isFormValid}
                >
                  {!customer?.id ? (
                    <FormattedMessage
                      id={
                        disableSubmit
                          ? 'reviews.reportForm.button.saving'
                          : 'reviews.reportForm.button.save'
                      }
                      defaultMessage={disableSubmit ? 'Saving...' : 'Save'}
                    />
                  ) : (
                    <FormattedMessage
                      id={
                        disableSubmit
                          ? 'reviews.reportForm.button.saving'
                          : 'reviews.reportForm.button.save_direct_chat'
                      }
                      defaultMessage={disableSubmit ? 'Saving...' : 'Save and Open Chat'}
                    />
                  )}
                </SaveButton>
                <SaveButton onClick={handleChatCustomer} disabled={!customer?.id}>
                  <FormattedMessage
                    id="reviews.reportForm.button.chat_customer"
                    defaultMessage="Chat Customer"
                  />
                </SaveButton>
              </>
            ) : (
              <>
                {currentStep > 0 ? (
                  <BackButton
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(currentStep - 1);
                    }}
                  >
                    <FormattedMessage id="reviews.reportForm.button.back" defaultMessage="Back" />
                  </BackButton>
                ) : (
                  <div></div>
                )}
                <SaveButton onClick={handleNextStep}>
                  <FormattedMessage
                    id="reviews.reportForm.button.continue"
                    defaultMessage="Continue"
                  />
                </SaveButton>
              </>
            )}
          </ButtonsContainer>
        )}
      </form>
    </>
  );
};

export default ReviewTicketFormTemplateSteps;
